
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Plotly } from 'vue-plotly';
import ChartHeading from '@/components/DataTab/Charts/ChartComponents/ChartHeading.vue';
import { ChartReturnType, LayoutType } from '@/types';
import store from '@/store';
import ChartComponent from './ChartComponent.vue';

@Component({ components: { Plotly, ChartHeading, ChartComponent } })
export default class BarChart extends Vue {
  @Prop({ type: Number, required: true }) chartId!: number;
  @Prop({ type: Array, required: true }) chartData!: ChartReturnType[];
  @Prop({ type: Array, required: false, default: null }) radioGroup!:
    | Record<string, string>[]
    | null;
  @Prop({ type: Boolean, default: false }) readonly showTooltip!: boolean;
  @Prop({ type: Boolean, default: true }) showLegendTip!: boolean;
  @Prop({ type: String, default: null }) chartSelection!: string | null;
  @Prop({ type: Boolean, default: false }) readonly hideDescription!: boolean;
  @Prop({ type: Boolean, default: false }) readonly hideUnit!: boolean;
  @Prop({ type: Boolean, default: false })
  readonly overrideChartSelection!: boolean;
  @Prop({ type: Boolean, default: false }) readonly headingOverride!: boolean;

  chartSelect = this.radioGroup ? this.chartSelection : '';

  get chartLoadingStatus() {
    return store.getters.chartStatus;
  }
  get selectedChart() {
    return this.overrideChartSelection
      ? this.chartId
      : store.getters.selectedChart;
  }

  get description() {
    return this.$t(`data.chartTables.${this.chartId}.description`);
  }

  get layout(): LayoutType {
    const yLabel =
      this.chartSelection && this.chartId !== 11
        ? this.$t(
            `data.chartTables.${this.selectedChart}.axisLabels.y.${this.chartSelection}`,
          )
        : this.$t(`data.chartTables.${this.selectedChart}.axisLabels.y`);

    // const unit = this.$t(`data.chartTables.${this.chartId}.unit`);
    const unit = this.chartSelection
      ? this.$t(
          `data.chartTables.${this.selectedChart}.unit.${this.chartSelection}`,
        )
      : this.$t(`data.chartTables.${this.selectedChart}.unit`);

    return {
      yaxis: {
        fixedrange: true,
        automargin: true,
        title: {
          text: this.hideUnit ? yLabel : `${yLabel} (${unit})`,
          standoff: 10,
        },
        hoverformat: ',.2f',
      },
      xaxis: {
        fixedrange: true,
        tickfont: {
          size: this.$vuetify.breakpoint.smAndDown
            ? 8
            : this.$vuetify.breakpoint.mdAndDown
            ? 9
            : 10,
        },
        tickangle: this.$vuetify.breakpoint.mdAndDown ? 90 : 0,
      },
      barmode: 'stack',
      hovermode: 'closest',
      legend: { orientation: 'h', y: -0.2 },
      paper_bgcolor: 'transparent',
      plot_bgcolor: 'transparent',
      margin: {
        l: 25,
        r: 25,
        b: 70,
        t: 5,
        pad: 3,
      },
    };
  }

  @Watch('chartSelect')
  watchSelection() {
    this.$emit('setSelection', this.chartSelect);
  }
}
